import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../../components/common/ConfirmationModal';
import styles from './TeacherClasses.module.css';
import { mockClasses } from './mockData';
import Button from '../../../components/common/Button/Button';
import { IconButton } from '../../../components/common/IconButton/IconButton';
import { DeleteIcon } from '../../../components/common/icons/deleteIcon';

export const TeacherClasses: React.FC = () => {
  const navigate = useNavigate();
  const [selectedClassId, setSelectedClassId] = useState<string | null>(null);

  const handleClassClick = () => {
    navigate('/docent/overzicht');
  };

  const handleLeaveConfirm = () => {
    // Here would be the API call to leave the class
    console.log('Leaving class:', selectedClassId);
    setSelectedClassId(null);
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>Mijn klassen</h1>
        <Button type="primary" onClick={() => console.log('Join class')}>
          Klas toevoegen
        </Button>
      </header>

      <div className={styles.classList}>
        {mockClasses.map(classItem => (
          <div key={classItem.id} className={styles.classItem} onClick={handleClassClick}>
            <div className={styles.classInfo}>
              <div className={styles.classMain}>
                <h2 className={styles.className}>{classItem.name}</h2>
                <p className={styles.classSubject}>{classItem.subject}</p>
              </div>
              <div className={styles.classStats}>
                <div className={styles.statItem}>
                  <span>{classItem.studentsCount}</span>
                  <span>studenten</span>
                </div>
                <div className={styles.statItem}>
                  <span>{classItem.teachersCount}</span>
                  <span>docenten</span>
                </div>
              </div>
            </div>
            <div className={styles.actions}>
              <IconButton icon={DeleteIcon} onClick={() => console.log('leave class')} label="Klas verlaten" />
            </div>
          </div>
        ))}
      </div>

      <ConfirmationModal
        isOpen={!!selectedClassId}
        onClose={() => setSelectedClassId(null)}
        onConfirm={handleLeaveConfirm}
        title="Klas verlaten"
        text={
          selectedClassId
            ? `Weet je zeker dat je ${
                mockClasses.find(c => c.id === selectedClassId)?.name
              } wilt verlaten? Je hebt daarna geen toegang meer tot de lessen en voortgang van deze klas.`
            : ''
        }
        confirmLabel="Verlaten"
        cancelLabel="Annuleren"
      />
    </div>
  );
};

export default TeacherClasses;
